import React from 'react';
import PropTypes from 'prop-types';

export default function BreederProfileEmptyResults({ breedName }) {
  return (
    <div className="BreederProfileEmptyResults tc">
      <h4 className="mb9">No results yet for {breedName} Breeders</h4>
    </div>
  );
}

BreederProfileEmptyResults.propTypes = {
  breedName: PropTypes.string.isRequired
};
